<template>
  <!-- insert app config form -->
  <div class="p-col-12 p-md-9 p-mx-auto p-mt-2">
    <div class="p-text-right">
        <Button
          label="Add New Config"
          @click="isNewConfigFormVisible = !isNewConfigFormVisible"
          class="p-button-sm p-button-text p-button-outlined p-button-info p-text-right" /> 
    </div>
  </div>

  <transition name="expand">
    <div v-show="isNewConfigFormVisible" class="p-grid p-jc-center p-p-4">
      <div class="card p-col-12 p-md-9 p-mx-auto p-p-4">
        <div class="p-grid">
          <div class="p-col-12 p-md-2">
            <Dropdown class="p-text-left" style="width: 100% !important" placeholder="Select OS"
              v-model="newConfigForm.os" :options="osList" optionLabel="name" optionValue="code" />
          </div>
          <div class="p-col-12 p-md-3">
            <span class="p-float-label">
              <InputText class="p-col-12" id="key" type="text" v-model="newConfigForm.key" />
              <label for="key">Key</label>
            </span>
          </div>
          <div class="p-col-12 p-md-3">
            <span class="p-float-label">
              <InputText class="p-col-12" id="value" type="text" v-model="newConfigForm.value" />
              <label for="value">Value</label>
            </span>
          </div>
          <div class="p-col-12 p-md-4">
            <span class="p-float-label">
              <Textarea class="p-col-12" id="comment" type="text" rows="2" :autoResize="true" v-model="newConfigForm.comment" />
              <label for="comment">Comment</label>
            </span>
          </div>
        </div>
        <div class="p-grid p-jc-end p-m-0 p-pt-2">
          <Button @click="addConfig()" label="Insert App Config" class="p-button p-button-info" />
        </div>
      </div>
    </div>
  </transition>

  <ProgressBar mode="indeterminate" v-show="isItemListLoading" style="height: .2em" />

  <div class="p-grid">
    <div class="p-col-12 p-md-9 p-mx-auto p-mt-2">
      <DataTable v-show="configList !== null && configList.length > 0" :paginator="true" :rows="25" :rowHover="true"
        :value="configList" editMode="row" dataKey="id" v-model:filters="filters" filterDisplay="menu"
        v-model:editingRows="editingRows" @row-edit-save="onRowEditSave" responsiveLayout="scroll"
        :globalFilterFields="['id','os','key','value','comment', 'last_updated_date']" >
          <Column field="id" header="#" sortable style="width:5%"></Column>
          <Column field="os" header="OS" sortable style="width:5%">
            <template #body="{data}">
              {{osName(data.os)}}
            </template>
            <template #editor="{data, field}">
              <Dropdown class="p-text-left" style="width: 100% !important" placeholder="Select OS"
                v-model="data[field]" :options="osList" optionLabel="name" optionValue="code" />
            </template>
          </Column>
          <Column field="key" header="Key" sortable style="width:20%">
            <template #body="{data}">
              {{data.key}}
            </template>
            <template #editor="{data, field}">
              <span class="p-float-label">
                <InputText v-model="data[field]" class="p-col-12" id="key" type="text" />
              </span>
            </template>
            <template #filter="{filterModel}">
              <InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Search by Key"/>
            </template>
          </Column>
          <Column field="value" header="Value" sortable style="width:20%">
            <template #body="{data}">
              {{data.value}}
            </template>
            <template #editor="{data, field}">
              <span class="p-float-label">
                <InputText v-model="data[field]" class="p-col-12" id="value" type="text" />
              </span>
            </template>
            <template #filter="{filterModel}">
              <InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Search by Value"/>
            </template>
          </Column>
          <Column field="comment" header="Comment" style="width:20%">
            <template #body="{data}">
              <div v-html="getFormattedComment(data.comment)"></div>
            </template>
            <template #editor="{data, field}">
              <Textarea v-model="data[field]" rows="2" :autoResize="true" class="p-col-12" id="comment" />
            </template>
            <template #filter="{filterModel}">
              <InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Search by Comment" />
            </template>
          </Column>
          <Column field="last_updated_date" header="Last Update" sortable dataType="date" class="p-text-center" style="width:15%; line-height: 1.25rem;">
            <template #body="{data}">
              <div v-html="getFormattedDate(data.last_updated_date)" style="width:100%"></div>
            </template>
            <template #editor="{}"></template>
          </Column>
          <Column :rowEditor="true" style="width:10%" bodyStyle="text-align:right;"></Column>
          <Column header="" style="width:5%" bodyStyle="text-align:left;">
            <template #body="item">
              <div style="">
                <Button label="" icon="pi pi-trash" class="p-button-rounded p-button-text p-button-plain"
                  @click="deleteConfig(item.data.id)" />
              </div>
            </template>
            <template #editor="{}"></template>
          </Column>
      </DataTable>
    </div>
  </div>

  <Divider align="center" class="p-mt-6">
    <div class="p-d-inline-flex p-ai-center">
      <b>About</b>
    </div>
  </Divider>

  <div class="p-col-12 p-md-9 p-mx-auto p-mt-2 p-text-left">
    <div class="p-d-flex">
      <i class="fa fa-info p-mr-3"></i> Uygulamalarda kullanılan genel ayarlar buradan yönetilir.
      <br/> Kullanım şartları url, Gizlilik politikası url, Yorumlar için max. karakter uzunluğu vb. gibi
    </div>
  </div>
</template>

<script>
import { FilterMatchMode, FilterOperator } from 'primevue/api'
import Dropdown from 'primevue/dropdown'
import InputText from 'primevue/inputtext'
import Textarea from 'primevue/textarea'
import Button from 'primevue/button'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import ProgressBar from 'primevue/progressbar'
import Divider from 'primevue/divider'

import Const from '../utils/const'
import { isEmpty } from '../utils/utils'
import moment from 'moment'

export default {
  name: 'ConfigApp',
  emits: ["loginResult", "pageLoaded"],
  components: {
    Dropdown, InputText, Textarea, Button, DataTable, ProgressBar, Column, Divider
  },
  data() {
    return {
      osList: [
        { code: 'all', name: 'All'},
        { code: 'and', name: 'Android'},
        { code: 'ios', name: 'iOS'}
      ],
      newConfigForm: {},
      isNewConfigFormVisible: false,
      isItemListLoading: false,
      configList: [],
      editingRows: [],
      filters: {
        'os': {value: null, matchMode: FilterMatchMode.CONTAINS},
        'key': {value: null, matchMode: FilterMatchMode.CONTAINS},
        'value': {value: null, matchMode: FilterMatchMode.CONTAINS},
        'comment': {value: null, matchMode: FilterMatchMode.CONTAINS},
        'last_updated_date': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.DATE_IS}]}
      }
    }
  },
  beforeMount() {
      var page = {
          title: "App Config"
      }
      this.$emit('pageLoaded', page)
  },
  mounted() {
    this.loadConfig()
  },
  methods: {
    osName(osValue) {
      var value = ''
      this.osList.forEach(item => {
        if(item.code === osValue)
          value = item.name
      })

      return value;
    },
    loadConfig() {
      let self = this,
          cookies = self.$cookies,
          toast = self.$toast,
          token = cookies.get('token');

      self.isItemListLoading = true
      self.$http.get('api/config/app', {
        headers: {
          'authorization': 'Bearer ' + token
          }
      })
      .then(function (response) {
          self.isItemListLoading = false
          if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
            cookies.set('token', response.headers['refresh-token']);
              self.configList = response.data.items
          } else if(response.data.kod === Const.KOD.oturumSonlandi) {
            self.$router.push('/login')
          } else {
            toast.add({severity:'warn', summary: 'Loading app config failed', detail:response.data.mesaj, life: 3000});
          }
      })
      .catch(function (err) {
        self.isItemListLoading = false
        toast.add({severity:'error', summary: 'Error', detail:err});
        console.log(err)
      });
    },
    onRowEditSave(event) {
      let { newData, index } = event;

      let self = this,
          configId = newData.id,
          newConfig = {
              id: configId,
              os: newData.os,
              key: newData.key,
              value: newData.value,
              comment: newData.comment
          },
          toast = self.$toast,
          toastMessage = null,
          cookies = self.$cookies,
          token = cookies.get('token');
      
      if(isEmpty(newConfig.os)) {
        toastMessage = 'OS is not selected!'
      } else if(isEmpty(newConfig.key)) {
        toastMessage = 'Key is empty!'
      } else if(isEmpty(newConfig.value)) {
        toastMessage = 'Value is empty!'
      }

      if(!isEmpty(toastMessage)) {
          toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
          return
      }

      self.$http.put('api/config/app/'+configId, newConfig, {
          headers: {
              'authorization': 'Bearer ' + token
          }
      })
      .then(function (response) {
          if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
            cookies.set('token', response.headers['refresh-token']);
            
            self.configList[index] = response.data.item;

            toast.add({severity:'success', summary: 'Success', detail: 'Updated successfully.', life: 3000});
          } else {
            toast.add({severity:'warn', summary: 'Update failed', detail:response.data.mesaj, life: 3000});
          }
      })
      .catch(function (err) {
          console.log(err)
          toast.add({severity: 'error', summary: 'Error', detail: err});
      });
    },
    addConfig() {
      let self = this,
          toast = self.$toast,
          newConfigForm = self.newConfigForm,
          toastMessage = null,
          cookies = self.$cookies,
          token = self.$cookies.get('token');

      if(isEmpty(newConfigForm.os)) {
        toastMessage = 'OS is not selected!'
      } else if(isEmpty(newConfigForm.key)) {
        toastMessage = 'Key is empty!'
      } else if(isEmpty(newConfigForm.value)) {
        toastMessage = 'Value is empty!'
      }

      if(!isEmpty(toastMessage)) {
          toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
          return
      }

      self.$http.post('api/config/app', newConfigForm, {
          headers: {
              'authorization': 'Bearer ' + token
          }
      })
      .then(function (response) {
        if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
          cookies.set('token', response.headers['refresh-token']);
          let newAddedItem = response.data.item
          
          self.configList.push(newAddedItem)

          toast.add({severity:'success', summary: 'Success', detail: 'App config added successfully.', life: 3000});

          self.newConfigForm = {}
        } else {
          console.log(response)
          toast.add({severity:'warn', summary: 'App config insert failed', detail:response.data.mesaj, life: 3000});
        }
      })
      .catch(function (err) {
        console.log(err)
        toast.add({severity: 'error', summary: 'Error', detail: err});
      });
    },
    deleteConfig(configId) {
      let self = this,
          toast = self.$toast,
          cookies = self.$cookies,
          token = self.$cookies.get('token');
      
      this.$confirm.require({
          message: 'Are you sure you want to delete this app config permanently?',
          header: 'Delete',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: 'Delete',
          rejectLabel: 'Cancel',
          accept: () => {
            self.$http.delete('api/config/app/'+configId, {
              headers: {
                'authorization': 'Bearer ' + token
              }
            })
            .then(function (response) {
              if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                cookies.set("token", response.headers['refresh-token']);

                self.loadConfig()

                toast.add({severity:'success', summary: 'Success', detail: 'App config deleted successfully.', life: 3000});
              } else {
                console.log(response)
                toast.add({severity:'warn', summary: 'Delete app config failed', detail:response.data.mesaj, life: 3000});
              }
            })
            .catch(function (err) {
              console.log(err)
              toast.add({severity: 'error', summary: 'Error', detail: err});
            });
          },
          reject: () => {
          }
      });
    },
    getFormattedDate(logDate) {
      return moment(new Date(logDate)).format('DD/MM/YYYY HH:mm');
    },
    getFormattedComment(comment) {
      return !isEmpty(comment) ? comment.replaceAll('\n', '<br/>') : null
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep(.p-paginator) {
    .p-paginator-current {
        margin-left: auto;
    }
}

::v-deep(.p-progressbar) {
    height: .5rem;
    background-color: #D8DADC;

    .p-progressbar-value {
        background-color: #607D8B;
    }
}

::v-deep(.p-datepicker) {
    min-width: 25rem;

    td {
        font-weight: 400;
    }
}

::v-deep(.p-datatable.p-datatable-customers) {
    .p-datatable-header {
        padding: 1rem;
        text-align: left;
        font-size: 1.5rem;
    }

    .p-paginator {
        padding: 1rem;
    }

    .p-datatable-thead > tr > th {
        text-align: left;
    }

    .p-datatable-tbody > tr > td {
        cursor: auto;
    }

    .p-dropdown-label:not(.p-placeholder) {
        text-transform: uppercase;
    }
}
</style>